module.exports = __webpack_public_path__ + "static/media/Frutiger-Light.7af927cc.otf";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Print/fonts/Frutiger-Light.otf
// module id = 114
// module chunks = 0